



























import MNotificationVue from "@/mixins/MNotification.vue";
import {
  ALLOWED_FILE_SIZE,
  ALLOWED_IMAGE_FILE,
  ALLOWED_PDF_FILE,
} from "@/models/constants/upload.constant";
import { ContractUploaderListDto } from "@/models/interface/contract-uploader/ContractUploaderListDto.interface";
import { FileCreateResponseDto } from "@/models/interface/storage";
import { contractUploaderService } from "@/services/ContractUploader.service";
import { UploadFile } from "ant-design-vue/types/upload";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

@Component
export default class ContractUploadModal extends Mixins(MNotificationVue) {
  ALLOWED_FILE_EXTENSIONS = [...ALLOWED_IMAGE_FILE, ...ALLOWED_PDF_FILE];
  MAX_FILE_SIZE_UPLOAD_MB = ALLOWED_FILE_SIZE / (1024 * 1024);

  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: null }) record!: ContractUploaderListDto | null;

  uploading = false;
  fileList: UploadFile[] = [];
  selectedFile: File | null = null;

  get modalTitle(): string {
    if (!this.record) return "";
    return this.$t("lbl_upload_contract_title", {
      documentNo: this.record.documentNo,
    }).toString();
  }

  @Watch("visible")
  onVisibleChanged(newVal: boolean): void {
    if (newVal) {
      // Reset state when modal opens
      this.fileList = [];
      this.selectedFile = null;
    }
  }

  beforeUpload(file: File): boolean {
    const fileExtension = "." + file.name.split(".").pop()?.toLowerCase();
    const isValidType = this.ALLOWED_FILE_EXTENSIONS.includes(fileExtension);
    const isValidSize = file.size < ALLOWED_FILE_SIZE;

    if (!isValidType) {
      this.showNotifError("lbl_upload_info_4");
    } else if (!isValidSize) {
      this.showNotifError("lbl_message_file_size_exceeded", {
        fileSize: this.MAX_FILE_SIZE_UPLOAD_MB,
      });
    } else {
      this.selectedFile = file;
      this.fileList = [file as unknown as UploadFile];
    }

    return false;
  }

  handleChange(info: { file: UploadFile; fileList: UploadFile[] }): void {
    if (info.file.status === "removed") {
      this.fileList = [];
      this.selectedFile = null;
    }
  }

  async handleUpload(): Promise<void> {
    if (!this.selectedFile || !this.record) return;

    this.uploading = true;

    try {
      const formData = new FormData();
      formData.append("file", this.selectedFile);

      const minioResult: FileCreateResponseDto =
        await contractUploaderService.uploadToMinio(formData);
      const fileContract = `${minioResult.bucketName}/${minioResult.objectName}`;
      await contractUploaderService.updateFileContract(
        this.record.id,
        fileContract
      );

      this.showNotifSuccess("notif_file_upload_successfully", {
        filename: this.selectedFile.name,
      });
      this.$emit("success");
      this.handleClose();
    } catch (error: unknown) {
      this.showNotifError("notif_file_upload_failed", {
        filename: this.selectedFile.name,
      });
    } finally {
      this.uploading = false;
    }
  }

  handleClose(): void {
    this.$emit("close");
  }
}
